"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const b_1 = __importDefault(require("b_"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const types_1 = require("../types");
const curtain_styles_1 = __importDefault(require("./curtain.styles"));
const b = b_1.default.with('curtain');
/* interface AttachmentCurtainProps {
    status: AttachmentStatus;
    handleClick?: (event: MouseEvent) => void;
    text: string;
} */
function CurtainComponent(props) {
    const i18n = (0, i18n_1.default)(['attach']);
    const { status, handleClick, text } = props;
    const enabled = status === types_1.AttachmentStatus.Initial;
    const ended = status === types_1.AttachmentStatus.End;
    const clickable = Boolean(handleClick);
    const onClick = (0, react_2.useCallback)(e => {
        if (enabled && handleClick) {
            handleClick(e);
        }
    }, [enabled, handleClick]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b({ enabled, clickable, ended }), onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: curtain_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('wrap') }, { children: (0, jsx_runtime_1.jsx)("p", { children: text }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('button') }, { children: i18n(['watch']) }))] })));
}
exports.default = CurtainComponent;
